import { render, staticRenderFns } from "./classStudentList.vue?vue&type=template&id=29acaad8&"
import script from "./classStudentList.vue?vue&type=script&lang=js&"
export * from "./classStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports